<div
  class="relative flex items-center w-full p-5 rounded-2xl cursor-pointer transition-all duration-200 ease-in-out bg-theme-background/10 hover:bg-theme-background/20 border border-solid"
  [ngClass]="{
    'border-white/5 shadow-[inset_0_0_26px_rgba(255,255,255,0.11)]': !config.isSelected,
    'border-cyan-highlight shadow-[inset_0_0_26px_rgba(30,144,255,0.35)]': config.isSelected,
    'opacity-50 cursor-not-allowed': config.disabled,
    'cursor-pointer': !config.disabled
  }"
  (click)="handleItemClick()"
  tabindex="0"
  (keydown)="null"
>
<!-- Left Icon/Thumbnail -->
  @if (config.thumbnailConfig && config.thumbnailConfig.backgroundColorClasses && !(config.thumbnailSource | toString)) {
    <div class="flex-shrink-0 mr-4">
      <div
        class="flex items-center justify-center w-14 h-14 rounded-full"
        [ngClass]="config.thumbnailConfig.backgroundColorClasses ? (config.thumbnailConfig.backgroundColorClasses | drawItem:(index ?? 0) | toString) : 'bg-cyan'"
      >
        <span class="uppercase text-sm font-semibold">
          {{ config.title | toString | firstCharOfWords }}
        </span>
      </div>
    </div>
  }

  @if (config['mimetype']) {
    <div class="relative flex items-center justify-center w-14 h-14 mr-3">
      <nrc-media-preview
        class="top-0 left-0 w-full h-full overflow-hidden rounded-md"
        [mimetype]="config['mimetype']"
        [source]="config['thumbnailSource'] | toString"
        [thumbnailSource]="config['thumbnailSource'] | toString"
        [mediaPreviewTypes]="['image']"
        [classList]="'bg-[#fefefe1a] shadow-[0px 6px 14px #00000033] border-2 border-solid border-white/10 rounded-10'"
      />
    </div>
  }

  @if (config.icon && !config.thumbnailConfig && !config.mimetype) {
    <div class="flex-shrink-0 mr-4">
      <div class="flex items-center justify-center w-10 h-10 rounded-full bg-theme-background/10">
        <nrc-icon
          [name]="config.icon"
          class="w-6 h-6 text-white"
        />
      </div>
    </div>
  }

  <!-- Content Area - w-0 flex-1 forces flex item to start from 0 width for proper truncation -->
  <div class="w-0 flex-1 mr-4 overflow-hidden">
    <div class="flex flex-col gap-1 w-full">
      <!-- Title -->
      <h3 class="text-lg font-bold text-white truncate" [title]="config.title">
        {{ config.title }}
      </h3>

      <!-- Subtitle -->
      @if (config.subtitle) {
        <p class="text-sm text-white/50 line-clamp-1">
          {{ config.subtitle }}
        </p>
      }
    </div>
  </div>

  <!-- Action Buttons -->
  @if (config.actionButtons && config.actionButtons.length > 0) {
    <div class="flex items-center justify-center visible space-x-3 flex-shrink-0 md:group-hover:visible">
      @for (actionButton of config.actionButtons; track $index) {
        <nrc-button
          class="relative w-10 h-10"
          [icon]="actionButton?.icon"
          [label]="actionButton?.label"
          [buttonType]="actionButton?.buttonType"
          [role]="actionButton?.role"
          [tooltipText]="actionButton?.tooltipText"
          (clickEvent)="handleActionButtonClick(actionButton);"
        />
      }
    </div>
  }
</div>
